// Fee math — must stay in lock-step with /app/backend/fee_helpers.py.
//
// Teachers set their NET take-home per session. Students pay a grossed-up
// price that also covers our 15% platform cut, the 15% app store cut and
// Stripe's 1.75% + $0.30 AU processing fee. Everywhere a student sees a price in the UI we show
// `grossFromNet(package.price)`; teacher-facing displays keep the raw net.

export const PLATFORM_PCT = 0.15;
export const APP_STORE_PCT = 0.15;
export const STRIPE_PCT = 0.0175;
export const STRIPE_FIXED = 0.30;

const DENOM = 1 - PLATFORM_PCT - APP_STORE_PCT - STRIPE_PCT; // 0.6825

// Student-facing gross for a teacher's net rate. Rounds UP to the cent so
// we're never under-charging ourselves.
export const grossFromNet = (net) => {
  const n = Number(net || 0);
  if (!(n > 0)) return 0;
  const raw = (n + STRIPE_FIXED) / DENOM;
  return Math.ceil(raw * 100) / 100;
};

// Integer-cent math so the split matches the backend exactly. Mentor gets
// exactly their net; any rounding cent lands in the platform fee.
export const feeBreakdown = (net) => {
  const gross = grossFromNet(net);
  if (!gross) return { gross: 0, platformFee: 0, appStoreFee: 0, stripeFee: 0, teacherNet: 0 };
  const g = Math.round(gross * 100);
  const n = Math.round(Number(net) * 100);
  const store = Math.floor((g * 15 + 50) / 100);
  const stripe = Math.floor((g * 175 + 5000) / 10000) + 30;
  const platform = g - n - store - stripe;
  return { gross, platformFee: platform / 100, appStoreFee: store / 100, stripeFee: stripe / 100, teacherNet: n / 100 };
};

// Convenience: "$65.00" / "$65" when integer.
export const fmtMoney = (n) => {
  const v = Number(n || 0);
  return v % 1 === 0 ? `$${v.toFixed(0)}` : `$${v.toFixed(2)}`;
};
